import { render, staticRenderFns } from "./goodsInfo.vue?vue&type=template&id=907230be&scoped=true"
import script from "./goodsInfo.vue?vue&type=script&lang=js"
export * from "./goodsInfo.vue?vue&type=script&lang=js"
import style0 from "./goodsInfo.vue?vue&type=style&index=0&id=907230be&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "907230be",
  null
  
)

export default component.exports